import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'

import index from '@/components/mode/index'
import joker from '@/components/mode/joker'
import concise from '@/components/mode/concise'
import realbet from '@/components/mode/realbet'
import gaming from '@/components/mode/gaming'
import lottery from '@/components/mode/lottery'
import sport from '@/components/mode/sport'
import login from '@/components/mode/login'
import register from '@/components/mode/register'
import footAll from '@/components/mode/footAll'


import mine from '@/components/mine/mine'
import redpacket from '@/components/mine/redpacket'
import center from '@/components/mine/center'
import message from '@/components/mine/message'
import fanshui from '@/components/mine/fanshui'
import betRecord from '@/components/mine/betRecord'
import transRecord from '@/components/mine/transRecord'
import transfer from '@/components/mine/transfer'
import withdraw from '@/components/mine/withdraw'
import recharge from '@/components/mine/recharge'
import bankSet from '@/components/mine/bankSet'
import welfare from '@/components/mine/welfare'
import apply from '@/components/mine/apply'


import gamePage from '@/components/gamePage'
import activity from '@/components/activity'
import activityapyList from '@/components/activityapyList'
import userredpacket from '@/components/userredpacket'
import activityInfo from '@/components/activityInfo'
import app from '@/components/app'
import vip from '@/components/vip'
import payInfo from '@/components/payInfo'






Vue.use(Router)

export default new Router({
  // mode: 'history',
  mode: 'hash',

  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }

        }, {
          path: '/joker',
          name: 'joker',
          component: joker,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/concise',
          name: 'concise',
          component: concise,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/realbet',
          name: 'realbet',
          component: realbet,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/gaming',
          name: 'gaming',
          component: gaming,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/lottery',
          name: 'lottery',
          component: lottery,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/sport',
          name: 'sport',
          component: sport,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/login',
          name: 'login',
          component: login,

        }, {
          path: '/register',
          name: 'register',
          component: register,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/footAll',
          name: 'footAll',
          component: footAll,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/mine',
          name: 'mine',
          component: mine,
          meta: {
            requireAuth: true,

          },
          children: [
            {
              path: '/redpacket',
              name: 'redpacket',
              component: redpacket,

            }, {
              path: '/center',
              name: 'center',
              component: center,
              meta: {
                keepAlive: true,//是否缓存组件
                useCatch: false//是否用缓存
              }
            }, {
              path: '/message',
              name: 'message',
              component: message,

            }, {
              path: '/fanshui',
              name: 'fanshui',
              component: fanshui,

            }, {
              path: '/betRecord',
              name: 'betRecord',
              component: betRecord,

            }, {
              path: '/transRecord',
              name: 'transRecord',
              component: transRecord,

            }, {
              path: '/transfer',
              name: 'transfer',
              component: transfer,

            }, {
              path: '/withdraw',
              name: 'withdraw',
              component: withdraw,
              meta: {
                requireAuth: true,
                keepAlive: true,//是否缓存组件
                useCatch: false//是否用缓存
              }

            }, {
              path: '/recharge',
              name: 'recharge',
              component: recharge,
              meta: {
                requireAuth: true,
                keepAlive: true,//是否缓存组件
                useCatch: false//是否用缓存
              }
            }, {
              path: '/bankSet',
              name: 'bankSet',
              component: bankSet,
              meta: {
                keepAlive: true,//是否缓存组件
                useCatch: false//是否用缓存
              }
            }, {
              path: '/welfare',
              name: 'welfare',
              component: welfare,

            }, {
              path: '/apply',
              name: 'apply',
              component: apply,

            }
          ]
        }
      ]
    }, {
      path: '/gamePage',
      name: 'gamePage',
      component: gamePage,
    }, {
      path: '/activity',
      name: 'activity',
      component: activity,

    }
    , {
      path: '/activityInfo',
      name: 'activityInfo',
      component: activityInfo,
    }
    , {
      path: '/activityapyList',
      name: 'activityapyList',
      component: activityapyList,
    }, {
      path: '/userredpacket',
      name: 'userredpacket',
      component: userredpacket,
    }, {
      path: '/app',
      name: 'app',
      component: app,
    }, {
      path: '/vip',
      name: 'vip',
      meta: {
        requireAuth: true,
      },
      component: vip,
    }, {
      path: '/payInfo',
      name: 'payInfo',
      component: payInfo,
    }
    , {
      path: '*', // 重定向页面地址
      redirect: '/'
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js